import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '@core/services/auth/auth.service';
import { SftpInfo, SftpInfoState } from '@core/services/sftp/sftp-info.model';
import { SftpInfoService } from '@core/services/sftp/sftp-info.service';
import { Store } from '@ngrx/store';

@Component({
  selector: 'Teranet-SftpEdit',
  templateUrl: './sftp-edit.component.html',
})
export class SftpEditComponent implements OnInit {
  id: number;
  sftpForm: FormGroup;
  sftps: SftpInfo[] = [];

  constructor(
    private fb: FormBuilder,
    private store: Store<SftpInfoState>,
    public dialogRef: MatDialogRef<SftpEditComponent>,
    private auth: AuthService,
    private sftpService: SftpInfoService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.sftpForm = new FormGroup({
      id: new FormControl(0),
      hostname: new FormControl('', Validators.required),
      sftpname: new FormControl('', Validators.required),
      port: new FormControl('', [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
      username: new FormControl('', Validators.minLength(5)),
      password: new FormControl('', Validators.minLength(4)),
      isexternal: new FormControl(true),
      isenabled: new FormControl(true),
    });
  }

  ngOnInit() {
    if (this.data.row != null) {
      this.sftpService.AllSftpInfo().subscribe(data => {
        this.sftps = data as SftpInfo[];
        this.id = this.data.row.id;
        this.sftpForm.patchValue({ ...this.data.row });
      });
    }
  }

  onClose(): void {
    this.dialogRef.close(this.sftpForm.value);
  }

  updateSftp(form: NgForm) {
    if (this.sftpForm.valid) {
      const updatedSftp: SftpInfo = {
        id: this.id,
        hostname: this.sftpForm.get('hostname').value,
        sftpname: this.sftpForm.get('sftpname').value,
        port: Number(this.sftpForm.get('port').value),
        username: this.sftpForm.get('username').value,
        password: this.sftpForm.get('password').value,
        isenabled: this.sftpForm.get('isenabled').value,
        isexternal: this.sftpForm.get('isexternal').value,
        isdeleted: false,
        lastupdatedby: this.auth.currentUserValue.username,
      };
      this.sftpService.updateSftp(updatedSftp).subscribe(data => {
        let test = data;
      });
      this.dialogRef.close(updatedSftp);
      form.resetForm();
    }
  }
}
